// plugins/drawing/index.ts

import type { PluginDefinition } from "../types";
import { DrawPluginComponent } from "./DrawPlugin";
import
{
  DRAW_SOURCE_ID,
  DRAW_FEATURE_COLOR,
  DRAW_FEATURE_STROKE_COLOR,
  DRAW_FEATURE_STROKE_WIDTH,
} from "./consts";

export const DrawPlugin: PluginDefinition = {
  id: "draw",
  Component: DrawPluginComponent,
};

/**
 * Directly sets GeoJSON data on the draw map source, bypassing the Redux →
 * DrawPlugin → useEffect chain. Use this after dispatching updateFeature when
 * you need the polygon to appear immediately (e.g. on page load).
 *
 * Retries up to 10 animation frames (~160 ms) to handle the race where
 * DrawPlugin.useEffect hasn't yet created the source on a fresh map instance
 * (e.g. when navigating between pages).
 */
export const changeSourceData = (
  map: any,
  features: Array<{
    id: string;
    geometry: any;
    fill?: string;
    stroke?: string;
    strokeWidth?: number;
  }>,
) =>
{
  if (!map) return;

  const feats = features.map((f) =>
  {
    let geometry = f.geometry;
    if (geometry?.type === "Polygon")
    {
      const coords = geometry.coordinates[0];
      const first = coords[0];
      const last = coords[coords.length - 1];
      const closed =
        first[0] === last[0] && first[1] === last[1]
          ? coords
          : [...coords, coords[0]];
      geometry = { type: "Polygon", coordinates: [closed] };
    }
    return {
      type: "Feature",
      id: f.id,
      geometry,
      properties: {
        color: f.fill || DRAW_FEATURE_COLOR,
        fill: f.fill || DRAW_FEATURE_COLOR,
        stroke: f.stroke || DRAW_FEATURE_STROKE_COLOR,
        stroke_color: f.stroke || DRAW_FEATURE_STROKE_COLOR,
        stroke_width: f.strokeWidth || DRAW_FEATURE_STROKE_WIDTH,
      },
    };
  });

  const data = { type: "FeatureCollection", features: feats };

  const source = map.getSource(DRAW_SOURCE_ID);
  if (source)
  {
    source.setData(data);
  } else
  {
    map.addSource(DRAW_SOURCE_ID, { type: "geojson", data });
    console.log('addSource', data);
  }
};
